// extracted by mini-css-extract-plugin
export default {"tooltipElement":"KbUwT3"};